import { render, staticRenderFns } from "./LicensingDetails.vue?vue&type=template&id=ad3d91f0&"
import script from "./LicensingDetails.vue?vue&type=script&lang=js&"
export * from "./LicensingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports